import { render, staticRenderFns } from "./TableRowEditor.vue?vue&type=template&id=08d45bc4&scoped=true&"
import script from "./TableRowEditor.vue?vue&type=script&lang=js&"
export * from "./TableRowEditor.vue?vue&type=script&lang=js&"
import style0 from "./TableRowEditor.vue?vue&type=style&index=0&id=08d45bc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d45bc4",
  null
  
)

export default component.exports